(function($, undefined) {
	'use strict';

	var init = function() {
		var locale = $("html").attr("lang") + "-ca";

		moment.locale(locale);
		$('.moment-from-now').each(function(i, el) {
			var momentFromNow = moment($(el).attr("data-date"), "YYYY-MM-DD, HH:mm").fromNow();
			if (momentFromNow.indexOf("Invalid date") === -1) {
				$(el).text(momentFromNow);
			}
		});
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
